(function () {
    "use strict";

    const PRIORITY_DELIVERY_VARIANT_ID = 39568791863381;

    let _updateTimer = null;
    let _isRunning = false;
    let _lastRenderedSignature = null;

    const cartSignature = (data) =>
        (data.items ?? [])
            .map((it) => `${it.variant_id}:${it.quantity}`)
            .sort()
            .join(",");

    const isExternalCartMutation = (url) =>
        typeof url === "string" &&
        url.includes("app=zapiet") &&
        (url.includes("/cart/change") || url.includes("/cart/update"));

    const isCartItemsHandling = () =>
        !!document
            .getElementById("main-cart-items")
            ?.classList.contains("cart__items--disabled");

    const hasBypassHeader = (opts) => {
        const h = opts?.headers;
        if (!h) return false;
        return !!(
            h["X-Postmut-Guard"] ||
            (typeof h.get === "function" && h.get("X-Postmut-Guard"))
        );
    };

    const renderSectionInto = (container, html, selector) => {
        if (!container || !html) return;
        const parsed = new DOMParser().parseFromString(html, "text/html");
        const source = parsed.querySelector(selector);
        if (!source) return;
        const target = container.querySelector(selector) ?? container;
        target.innerHTML = source.innerHTML;
    };

    const afterExternalCartChange = async () => {
        _updateTimer = null;
        if (_isRunning) return;
        _isRunning = true;

        try {
            const mainCartItems =
                document.getElementById("main-cart-items");
            if (!mainCartItems) return;

            const beforeItemCount = document.querySelectorAll(
                "#main-cart-items .cart-item:not(.hidden)"
            ).length;
            const beforeItemTitles = [
                ...document.querySelectorAll(
                    "#main-cart-items .cart-item__name"
                )
            ].map((el) => el.textContent.trim());
            const beforeTotal =
                document
                    .querySelector(".totals__total-value")
                    ?.textContent.trim() ?? "—";

            console.group("[Atlas] External cart mutation — syncing");
            console.log("Before =>", {
                visibleItems: beforeItemCount,
                titles: beforeItemTitles,
                total: beforeTotal
            });

            const cartRes = await fetch("/cart.js", {
                credentials: "same-origin"
            });
            if (!cartRes.ok) {
                console.warn("[Atlas] Failed to fetch /cart.js");
                console.groupEnd();
                return;
            }
            const cartData = await cartRes.json();

            const initialSig = cartSignature(cartData);
            if (initialSig === _lastRenderedSignature) {
                console.log("[Atlas] Cart state unchanged — skipping re-render");
                console.groupEnd();
                return;
            }

            const attrs = cartData.attributes ?? {};
            const priorityDelivery = String(
                attrs["Priority-Delivery"] ?? ""
            ).toLowerCase();
            const checkoutMethod = String(
                attrs["Checkout-Method"] ?? ""
            ).toLowerCase();
            const isDelivery = checkoutMethod === "delivery";
            const shouldAdd = priorityDelivery === "yes" && isDelivery;

            const priorityItemInCart = cartData.items?.find(
                (it) =>
                    Number(it.variant_id) === PRIORITY_DELIVERY_VARIANT_ID
            );

            console.log("Cart attributes =>", attrs);
            console.log("Priority-Delivery check =>", {
                "Priority-Delivery": attrs["Priority-Delivery"] ?? "—",
                "Checkout-Method": attrs["Checkout-Method"] ?? "—",
                shouldAdd,
                "itemInCart": !!priorityItemInCart
            });

            let priorityItemAdded = false;
            let priorityItemRemoved = false;

            if (shouldAdd && !priorityItemInCart) {
                console.log(
                    `Adding variant ${PRIORITY_DELIVERY_VARIANT_ID} (Priority Delivery, qty 1)`
                );
                const addRes = await fetch("/cart/add.js", {
                    method: "POST",
                    credentials: "same-origin",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Postmut-Guard": "1"
                    },
                    body: JSON.stringify({
                        items: [
                            {
                                id: PRIORITY_DELIVERY_VARIANT_ID,
                                quantity: 1
                            }
                        ]
                    })
                });
                priorityItemAdded = addRes.ok;
                console.log(
                    priorityItemAdded
                        ? "Priority item added ✓"
                        : "Failed to add priority item ✗"
                );
            } else if (!isDelivery && priorityItemInCart) {
                console.log(
                    `Checkout-Method "${attrs["Checkout-Method"]}" is not delivery — removing variant ${PRIORITY_DELIVERY_VARIANT_ID}`
                );
                const removeRes = await fetch("/cart/update.js", {
                    method: "POST",
                    credentials: "same-origin",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Postmut-Guard": "1"
                    },
                    body: JSON.stringify({
                        updates: {
                            [String(PRIORITY_DELIVERY_VARIANT_ID)]: 0
                        }
                    })
                });
                priorityItemRemoved = removeRes.ok;
                console.log(
                    priorityItemRemoved
                        ? "Priority item removed ✓"
                        : "Failed to remove priority item ✗"
                );
            } else if (shouldAdd && priorityItemInCart) {
                console.log(
                    `Priority-Delivery "yes" + delivery — variant ${PRIORITY_DELIVERY_VARIANT_ID} already in cart`
                );
            } else {
                console.log("No Priority Delivery item adjustment needed");
            }

            const cartUrl = window.routes?.cart_url ?? "/cart";
            const cartItemsSectionId = mainCartItems.dataset.id;
            const mainCartFooter =
                document.getElementById("main-cart-footer");
            const cartFooterSectionId = mainCartFooter?.dataset.id ?? null;

            const [updatedCart, itemsHtml, footerHtml] = await Promise.all([
                priorityItemAdded || priorityItemRemoved
                    ? fetch("/cart.js", {
                          credentials: "same-origin"
                      }).then((r) => (r.ok ? r.json() : cartData))
                    : Promise.resolve(cartData),

                fetch(`${cartUrl}?section_id=${cartItemsSectionId}`, {
                    credentials: "same-origin"
                }).then((r) => (r.ok ? r.text() : null)),

                cartFooterSectionId
                    ? fetch(
                          `${cartUrl}?section_id=${cartFooterSectionId}`,
                          { credentials: "same-origin" }
                      ).then((r) => (r.ok ? r.text() : null))
                    : Promise.resolve(null)
            ]);

            console.log("Fetched =>", {
                item_count: updatedCart?.item_count,
                total_price: updatedCart?.total_price,
                attributes: updatedCart?.attributes,
                items: updatedCart?.items?.map((it) => ({
                    title: it.title,
                    qty: it.quantity,
                    variant_id: it.variant_id
                }))
            });

            _lastRenderedSignature = cartSignature(updatedCart);

            renderSectionInto(mainCartItems, itemsHtml, ".js-contents");
            renderSectionInto(mainCartFooter, footerHtml, ".js-contents");

            const sectionsUpdated = [
                itemsHtml ? "#main-cart-items (.js-contents)" : null,
                footerHtml ? "#main-cart-footer (.js-contents)" : null
            ].filter(Boolean);

            const itemCount = Number(updatedCart?.item_count ?? 0);
            document
                .querySelector("cart-items")
                ?.classList.toggle("is-empty", itemCount === 0);
            mainCartFooter?.classList.toggle("is-empty", itemCount === 0);

            try {
                window.__cvpSyncBubble?.();
            } catch (_) {}

            const afterItemTitles = [
                ...document.querySelectorAll(
                    "#main-cart-items .cart-item__name"
                )
            ].map((el) => el.textContent.trim());
            const afterTotal =
                document
                    .querySelector(".totals__total-value")
                    ?.textContent.trim() ?? "—";

            console.log("After  =>", {
                visibleItems: itemCount,
                titles: afterItemTitles,
                total: afterTotal,
                isEmpty: itemCount === 0
            });
            console.log("Sections re-rendered:", sectionsUpdated);
            console.groupEnd();
        } catch (err) {
            console.warn("[Atlas] afterExternalCartChange failed:", err);
            console.groupEnd();
        } finally {
            _isRunning = false;
        }
    };

    const _prevFetch = window.fetch;

    window.fetch = async function (...args) {
        const res = await _prevFetch.apply(this, args);
        try {
            const [req, opts] = args;
            const url = typeof req === "string" ? req : req?.url ?? "";

            if (
                !hasBypassHeader(opts) &&
                isExternalCartMutation(url) &&
                res.ok &&
                !isCartItemsHandling()
            ) {
                clearTimeout(_updateTimer);
                _updateTimer = setTimeout(afterExternalCartChange, 1000);
            }
        } catch (_) {}
        return res;
    };
})();
